import { Dialog } from "@progress/kendo-react-dialogs";
import React from "react";
import "./employee_concern.css";
import { Checkbox, RadioButton, TextBox } from "@progress/kendo-react-inputs";
import DatePicker from "react-datepicker";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import moment from "moment";
import { statusConfig } from "./configData";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";

export const Search = (props) => {

  return (
    <Dialog width={395} height={"100%"} className="employee_concern_filter_dialog">
      <div className="employee_concern_filter_main_box">
        <div style={{ position: "relative" }}>
          <div
            className="employee_concern_filter_cross_icon"
            onClick={() => props.setShowFilter(false)}
          >
            <span class="k-icon k-font-icon k-i-close k-icon-xl" />
          </div>
        </div>
        <div className="employee_concern_filter_header_box">
          <div className="employee_concern_filter_header_title">Search</div>
        </div>
        <div className="employee_concern_filter_detail_main_box">

          <div className="employee_concern_filter_detail_date_box">
            <div className="employee_concern_filter_detail_title">By Submission No.</div>
            <div className="employee_concern_filter_radio_button_main_box">
              <TextBox
                className="campaigns_create_item_main_box_field"
                value={props.searchValue.submission_no}
                onChange={(e) =>
                  props.setSearchValue({
                    ...props.searchValue,
                    submission_no: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="employee_concern_filter_detail_date_box">
            <div className="employee_concern_filter_detail_title">By Submitter's Name</div>
            <div className="employee_concern_filter_radio_button_main_box">
              <TextBox
                className="campaigns_create_item_main_box_field"
                value={props.searchValue.submitter_name}
                onChange={(e) =>
                  props.setSearchValue({
                    ...props.searchValue,
                    submitter_name: e.target.value,
                  })
                }
              />
            </div>

          </div>


        </div>
        <div className="employee_concern_filter_footer_main_box">
          <div
            className="employee_concern_filter_footer_cancel"
            onClick={() => props.setShowSearch(false)}
          >
            Cancel
          </div>
          <div
            className="employee_concern_filter_footer_submit"
            onClick={props.SearchAction}
          >
            Submit
          </div>
        </div>
      </div>
    </Dialog>
  );
};
